var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kategorie-filter"},[_c('b-form-group',{attrs:{"label":"Kategorie","label-cols":11}},[_c('b-form-select',{attrs:{"value":_vm.selectedKategorie,"options":_vm.options,"plain":true},on:{"change":_vm.updateFilter}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }